import { defineComponent as _defineComponent } from 'vue'
import BrandLogosWidgetCarouselLayout from './BrandLogosWidgetCarouselLayout.vue';
import BrandLogosWidgetItem from './BrandLogosWidgetItem.vue';
import BrandLogosWidgetStackedLayout from './BrandLogosWidgetStackedLayout.vue';
import { BrandLogosWidgetResource } from 'JS/dxp/types/widgets/brand-logos-widget';
import { computed } from 'vue';
import { createPromoDataAttributes } from 'JS/utilities/analytics';


export default /*#__PURE__*/_defineComponent({
  __name: 'BrandLogosWidget',
  props: {
    widget: null
  },
  setup(__props: any) {

const props = __props as {
	widget: BrandLogosWidgetResource;
}



const layoutComponent = computed(() => {
	switch (props.widget.widget.layout) {
		case 'stacked':
			return BrandLogosWidgetStackedLayout;
		case 'carousel':
		default:
			return BrandLogosWidgetCarouselLayout;
	}
});


const gaDataAttributes = computed(() => createPromoDataAttributes({
	promoId: `${props.widget.widget.title}`, //PromoID same as PromoName, since it is usually the link, but there is no shop all button
	creativeSlot: "dxp_circle_widget_0",
	creativeName: `dxp_circle_widget_${props.widget.widget.layout}`,
	promoName: `${props.widget.widget.title}`
}));


return { __sfc: true,props, layoutComponent, gaDataAttributes, BrandLogosWidgetItem }
}

})